import type { MembershipPlansPreviewConfig } from '@provision/membership-plans-ui';
import type { LandingPagePlansData } from './types';

/**
 * Products are passed through in the order given — the caller pre-orders, because the two
 * consumers order differently: the portal's arrive sorted by the plans tab, while a public page
 * applies the partner's saved `productOrder`. Sorting here would override both.
 */
export function toLandingPagePlansData(
  plansConfig: MembershipPlansPreviewConfig | null,
): LandingPagePlansData {
  if (!plansConfig) return {};

  const options = plansConfig.options;

  return {
    products: plansConfig.products,
    features: plansConfig.features,
    faqs: options?.showFaq === false ? [] : options?.faqQuestions,
    mostPopularProductId: options?.mostPopularProductId,
    callForPricingPhone: options?.callForPricingPhone,
    showMonthlyPrices: options?.showMonthlyPrices,
    showAnnualPrices: options?.showAnnualPrices,
  };
}
